export default "__VITE_ASSET__Dy0g95Ja__"